// extracted by mini-css-extract-plugin
export var venue = "venue-module--venue--2SHB7";
export var inner = "venue-module--inner--Z_Q5X";
export var hero = "venue-module--hero--3VVon";
export var heroImage = "venue-module--heroImage--1cYWx";
export var img = "venue-module--img--2MIVP";
export var overlay = "venue-module--overlay--as40I";